const NATIVE_PRINT = window.print.bind(window);
const PRINT_PARAM = "modusprint";

// Browsers silently block window.print() inside a sandboxed iframe (the Emergent
// preview embeds the app this way), so the print dialog never appears. We route
// the request out to a real top-level tab and trigger the native dialog there.
export function installPrintShim() {
  window.print = function () {
    const framed = window.self !== window.top;
    if (!framed) {
      NATIVE_PRINT();
      return;
    }
    const url = new URL(window.location.href);
    url.searchParams.set(PRINT_PARAM, "1");
    const win = window.open(url.toString(), "_blank");
    if (!win) NATIVE_PRINT(); // popups blocked — best-effort fallback
  };

  // If this is the freshly-opened print tab, wait for the document to render,
  // then fire the native print dialog and close the tab afterwards.
  const params = new URLSearchParams(window.location.search);
  if (params.get(PRINT_PARAM) === "1") {
    let tries = 0;
    const ready = () =>
      document.querySelector(
        '[data-testid="export-pdf-button"],[data-testid="shared-print-button"]',
      );
    const timer = setInterval(() => {
      tries += 1;
      if (ready() || tries > 50) {
        clearInterval(timer);
        setTimeout(() => NATIVE_PRINT(), 500);
      }
    }, 200);
    window.addEventListener("afterprint", () => window.close());
  }
}
